import { apiPath } from "api";
import { generalAuthTokenHeader } from "__helpers/auth-header";

const fmt = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate()
  ).padStart(2, "0")}`;

export const organizationReportService = {
  fetchReport,
};

async function fetchReport({ facilityIds, startDate, endDate }) {
  const params = [
    `facilityIds=${facilityIds.join(",")}`,
    `from=${fmt(startDate)}`,
    `to=${fmt(endDate)}`,
  ].join("&");

  const response = await fetch(`${apiPath.organizationReport}?${params}`, {
    method: "GET",
    headers: generalAuthTokenHeader(),
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch organization report (HTTP ${response.status})`);
  }
  return response.json();
}
